// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js","802":"component---src-templates-data-collection-template-js"}[chunkId] || chunkId) + "-" + {"125":"b305447a5714d3d12343","293":"a9b2c6841136eeac589e","522":"d37b7941ecfbc7b12f24","802":"24073ffd908d6794358e"}[chunkId] + ".js";
};